import axios from './axios';

// 🔹 新增文章
export function createArticle(article) {
    return axios.post('/api/articles', article).then(res => res.data);
}

// 🔹 更新文章
export function updateArticle(id, article) {
    return axios.put(`/api/articles/${id}`, article).then(res => res.data);
}

// 🔹 刪除文章
export function deleteArticle(id) {
    return axios.delete(`/api/articles/${id}`).then(res => res.status === 200 || res.status === 204);
}

// 🔹 取得單一文章
export function getArticleById(id) {
    return axios.get(`/api/articles/${id}`).then(res => res.data);
}

// 🔹 分頁查詢文章
export function getArticlePage(page = 0, size = 10, sort = 'createdAt,desc', categoryId = null, tagId = null) {
    const params = { page, size, sort };
    if (categoryId) params.categoryId = categoryId;
    if (tagId) params.tagId = tagId;
    
    return axios.get('/api/articles/page', { params }).then(res => res.data);
}
